export default {
    conversations: state => state.conversations,
    messages: state => state.messages,
    info: state => state.info,
    conversationID: state => state.conversationID,
    chatNewMessages: state => state.chatNewMessages,
    getChatActionsCount: state => state.chatActionsCount,
    getIcebreaker: state => state.icebreaker,
};